
import type { ConfirmPasswordResetPayload } from 'libs/api-definition/src/api-definition-paths/nest-auth-paths/confirm-password-reset-path/confirm-password-reset-request-schema';
import type { ConfirmPasswordResetResponse } from 'libs/api-definition/src/api-definition-paths/nest-auth-paths/confirm-password-reset-path/confirm-password-reset-response-schema';
import { ConfirmPasswordResetResponseSchema } from 'libs/api-definition/src/api-definition-paths/nest-auth-paths/confirm-password-reset-path/confirm-password-reset-response-schema';
import { useMutation, type UseMutationOptions } from 'react-query';
import { getPublicApi } from '../../services/api';
import { handleResponseError } from './use-request-reset-password';

export function useConfirmPasswordReset(options?: UseMutationOptions<ConfirmPasswordResetResponse, unknown, ConfirmPasswordResetPayload>) {
  return useMutation({
    mutationFn: async ({ email, newPassword, verificationCode }) => {
      try {
        const api = getPublicApi();
  
        const confirmPasswordResetResponse = await api.confirmPasswordReset({ confirmPasswordResetRequest: { email, newPassword, verificationCode } });
  
        return ConfirmPasswordResetResponseSchema.parse(confirmPasswordResetResponse);
      } catch (error) {
        const errorResponse = await handleResponseError(error);
        throw new Error(errorResponse);
      }
    },
    ...options,
  });
}
